/** UI mode only: this flag never grants authentication or API permissions. */
const isCampusApp = (): boolean => {
	if (typeof window === 'undefined') return false;

	// The native UA marker survives auth redirects and document reloads.
	if (/\bCampusApp\/[\d.]+\b/.test(window.navigator.userAgent)) return true;

	// Query mode is useful for browser QA. Keep it for this tab only, so router
	// redirects do not send the tester back to the PWA installation screen.
	const query = new URLSearchParams(window.location.search).get('campusApp');
	try {
		if (query === '0') {
			window.sessionStorage.removeItem('campus-app-preview');
			return false;
		}
		if (query === '1') {
			window.sessionStorage.setItem('campus-app-preview', '1');
			return true;
		}
		return window.sessionStorage.getItem('campus-app-preview') === '1';
	} catch {
		// Storage can be unavailable in restricted browser contexts.
		return query === '1';
	}
};

export default isCampusApp;
